(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-materials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initMaterialsPage(sectionId) {
    var nav = document.getElementById('pm-sticky-nav--' + sectionId);
    if (!nav) return;

    var links = nav.querySelectorAll('.page-materials__nav-link');
    if (!links.length) return;

    /* smooth scroll */
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var href = link.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        var navH = nav.offsetHeight;
        var top = target.getBoundingClientRect().top + window.scrollY - navH - 8;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    /* active state via IntersectionObserver */
    if (!('IntersectionObserver' in window)) return;

    var sections = [];
    links.forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var el = document.getElementById(href.slice(1));
      if (el) sections.push({ el: el, link: link });
    });

    var navInner = nav.querySelector('.page-materials__sticky-nav-inner');
    var navSelect = document.getElementById('pm-nav-select--' + sectionId);
    var activeLink = null;

    function scrollToAnchor(anchorId) {
      var target = document.getElementById(anchorId);
      if (!target) return;
      var navH = nav.offsetHeight;
      var top = target.getBoundingClientRect().top + window.scrollY - navH - 8;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    /* mobile dropdown: scroll to section on change */
    if (navSelect) {
      navSelect.addEventListener('change', function () {
        scrollToAnchor(navSelect.value);
      });
    }

    function setActive(link) {
      if (activeLink === link) return;
      if (activeLink) activeLink.classList.remove('page-materials__nav-link--active');
      activeLink = link;
      if (activeLink) activeLink.classList.add('page-materials__nav-link--active');

      /* sync mobile dropdown to the active section */
      if (navSelect && activeLink) {
        var href = activeLink.getAttribute('href');
        if (href && href.charAt(0) === '#') navSelect.value = href.slice(1);
      }

      /* horizontally center the active tab in the nav strip (desktop only — guard when inner is hidden) */
      if (navInner && activeLink && navInner.clientWidth > 0) {
        var scrollTarget = activeLink.offsetLeft - (navInner.clientWidth / 2) + (activeLink.clientWidth / 2);
        navInner.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var match = sections.find(function (s) { return s.el === entry.target; });
            if (match) setActive(match.link);
          }
        });
      },
      {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0,
      }
    );

    sections.forEach(function (s) { observer.observe(s.el); });
  }

  function boot() {
    var sections = document.querySelectorAll('[id^="pm-sticky-nav--"]');
    sections.forEach(function (nav) {
      var sectionId = nav.id.replace('pm-sticky-nav--', '');
      initMaterialsPage(sectionId);
    });
  }

  document.addEventListener('shopify:section:load', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pendant-lp-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function initCard(card) {
    if (card.dataset.plpInit === 'true') return;
    card.dataset.plpInit = 'true';

    var dataEl = card.querySelector('.plp-bestsellers__variant-data');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var colorPosition = parseInt(card.dataset.colorPosition, 10) || 1;
    var optionKey     = 'option' + colorPosition;
    var imgEl         = card.querySelector('[data-plp-card-img]');
    var swatchInputs  = Array.from(card.querySelectorAll('.plp-bestsellers__swatch-input'));

    /* The quick-add snippet's hidden variant-id input — we keep this in sync */
    function getQuickAddInput() {
      return card.querySelector('quick-add-component input[name="id"]');
    }

    function getMatchedVariants(swatchValue) {
      return variants.filter(function (v) { return v[optionKey] === swatchValue; });
    }

    /* Swatch change: swap image + tell the site's quick-add which variant to add */
    swatchInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var matched = getMatchedVariants(input.dataset.swatchValue);
        if (!matched.length) return;

        var target = matched.find(function (v) { return v.available; }) || matched[0];

        /* Swap card image */
        if (imgEl && target.image) {
          imgEl.src = target.image;
          imgEl.removeAttribute('srcset');
        }

        /* Sync the quick-add component's variant input so it adds the right variant */
        var qaInput = getQuickAddInput();
        if (qaInput) qaInput.value = target.id;
      });
    });
  }

  function boot() {
    document.querySelectorAll('.plp-bestsellers__card:not([data-plp-init])').forEach(initCard);
  }

  document.addEventListener('shopify:section:load', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pendant-lp-mixmatch"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function formatMoney(cents) {
    var dollars = cents / 100;
    return '$' + (Number.isInteger(dollars) ? dollars : dollars.toFixed(2));
  }

  function initNudge(card) {
    if (card.dataset.nudgeInit === 'true') return;
    card.dataset.nudgeInit = 'true';

    var threshold   = parseInt(card.dataset.nudgeThreshold, 10) || 8500;
    var unlockedTxt = card.dataset.nudgeUnlockedText || 'Free shipping unlocked!';
    var amountEl    = card.querySelector('[data-nudge-amount]');
    var fillEl      = card.querySelector('[data-nudge-fill]');
    var trackEl     = card.querySelector('.plp-mixmatch__nudge-track');

    function render(cartTotal) {
      var remaining = Math.max(0, threshold - cartTotal);
      var pct       = Math.min(100, (cartTotal / threshold) * 100);

      fillEl.style.width = pct + '%';
      trackEl.setAttribute('aria-valuenow', Math.round(pct));

      if (remaining > 0) {
        amountEl.textContent = formatMoney(remaining) + ' to free shipping';
      } else {
        amountEl.textContent = unlockedTxt;
        amountEl.style.color = '#3a9e6e';
        fillEl.style.background = '#3a9e6e';
      }
    }

    function fetchAndRender() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price || 0); })
        .catch(function () { render(0); });
    }

    fetchAndRender();

    /* Re-render whenever the cart changes (UpCart dispatches cart:update) */
    document.addEventListener('cart:update', fetchAndRender);
    document.addEventListener('cart:updated', fetchAndRender);
  }

  function boot() {
    document.querySelectorAll('.plp-mixmatch__nudge:not([data-nudge-init])').forEach(initNudge);
  }

  document.addEventListener('shopify:section:load', boot);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
